import styled, { css } from 'styled-components/macro'
import { transparentize } from 'polished'
import SimpleBar from 'simplebar-react'

export const Wrap = styled.div`
  margin: 0;
  padding: 0;
  width: 100%;
  background-color: ${(props) => props.theme.color.transparent};
  &:last-child {
    margin: 0;
  }
`

export const Title = styled.h3`
  margin: 0;
  padding: 1.2rem 0.8rem;
  display: inline-block;
  width: 100%;
  font-family: ${(props) => props.theme.font.family.default};
  font-weight: ${(props) => props.theme.font.weight.bold};
  font-size: 2.4rem;
  line-height: 1.67;
  color: ${(props) => transparentize(0.5, props.theme.color.white)};
  transition: all 0.3s;
  &:hover,
  &.activeNavLink {
    color: ${(props) => props.theme.color.white};
  }
  ${(props) => props.theme.breakpoints.greaterThan('md')`
    font-size: 1.4rem;
    line-height: 1.43;
  `};
`

export const Header = styled.button<{ isOpen?: boolean }>`
  position: relative;
  margin: 0;
  padding: 0;
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  color: inherit;
  background-color: ${(props) => props.theme.color.transparent};
  border: none;
  transition: all 0.2s;
  cursor: pointer;
  &:hover,
  &:focus {
    outline: none;
    ${Title}, svg {
      color: ${(props) => props.theme.color.white};
    }
  }
  ${(props) =>
    props.isOpen &&
    css`
      border-color: ${(props) => props.theme.color.elementBorder};
    `}
  svg {
    transition: all 0.3s;
    transform: rotate(${({ isOpen }) => (isOpen ? '-180deg' : '0deg')});
  }
`

export const IconWrap = styled.span`
  margin: 0;
  color: ${(props) => transparentize(0.5, props.theme.color.white)};
`

export const ContentWrap = styled.div`
  position: absolute;
  top: 83%;
  padding: 0.4rem;
  background-color: #0c061a;
  border: 0.1rem solid rgba(108, 71, 255, 0.2);
  border-radius: 1.2rem;
  box-shadow: 0 0.8rem 2.4rem -0.6rem rgba(0, 0, 0, 0.16), 0 0 0.1rem rgba(0, 0, 0, 0.4);
`

export const Content = styled(SimpleBar)`
  padding: 0;
  width: 16.8rem;
  max-height: 18rem;
  overflow-x: hidden;
  overflow-y: auto;
`
